export default __webpack_public_path__ + "static/media/ic-cart-empty.ada2b481.svg";